import {
  SET_JOURNAL_TABLE_FILTER,
  UNSET_JOURNAL_TABLE_FILTER,
} from './types';

export const setJournalTableFilter = filter => ({
  type: SET_JOURNAL_TABLE_FILTER,
  filter,
});

export const unsetJournalTableFilter = () => ({
  type: UNSET_JOURNAL_TABLE_FILTER,
});
